import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { FontIcon } from 'react-toolbox';
import { updateSavedFilterPosition, updateSavedFilter } from 'actionCreators';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { Link } from 'react-router';
import S from './savedFilters.scss';
import SavedFilterItem from 'savedFilterItem';
import AssignedFilterItem from 'assignedFilterItem';
import PhaseLocationFilters from 'PhaseLocationFilters';
import SupervisorQuickFilter from './SupervisorQuickFilter';

class SavedFiltersList extends Component {
  state = { isDragging: false }

  selectFilter = filter => (e) => {
    e.preventDefault();
    this.props.onFilterSelect(filter);
  }

  move = (dragIndex, hoverIndex) => this.props.updateSavedFilterPosition(dragIndex, hoverIndex);

  beginDrag = () => this.setState({ isDragging: true })

  endDrag = (item, index) => {
    this.props.updateSavedFilter({ position: index }, item.id);
    this.setState({ isDragging: false });
  }

  render = () => {
    const { ignoreLocationFilters, selected, all_phase_count, all_phase_overdue_count,
            assignedFilters, savedFilters, hideSaved, role } = this.props;
    return (<div>
      {ignoreLocationFilters ? (<h2 className={S.disabledHeader}>
        <FontIcon value="report_problem" />
        Filters Disabled<FontIcon value="report_problem" />
      </h2>) : (<Fragment>
        {!['installer', 'estimator'].includes(role) && <Fragment>
          <h4 className={S.header}>Quick Filters</h4>
          <PhaseLocationFilters />
          {this.props.canAccessSupervisorFilter && (
            <SupervisorQuickFilter
              filters={this.props.filters}
              onChange={this.props.onSupervisorChange}
            />
          )}
        </Fragment>}
        <h4 className={S.header}>Default Filter</h4>
        <div className={cx(S.filter, { [S.selected]: !selected })} >
          <Link to="/phases">
            <span className={S.name}>All Phases</span>
            {all_phase_count && <span className={S.count}>
              {all_phase_overdue_count}/{all_phase_count}
            </span>}
          </Link>
        </div>
        {assignedFilters.length > 0 && <div>
          <h4 className={S.header}>Assigned Filters</h4>
          <ul className={S.list}>
            {assignedFilters.map((filter, i) => <AssignedFilterItem
              key={filter.id}
              item={filter}
              index={i}
              selected={filter.id === (selected &&
                                       selected.type === 'assigned' &&
                                       selected.id)}
              onFilterSelect={this.selectFilter(filter)}
            />)}
          </ul>
        </div>}
        {!hideSaved && <Fragment>
          <h4 className={S.header}>Saved Filters</h4>
          <ul className={cx(S.list, { [S.dragging]: this.state.isDragging })}>
            {savedFilters.map((filter, i) => <SavedFilterItem
              key={filter.id}
              item={filter}
              index={i}
              selected={filter.id === (selected &&
                                       selected.type === 'saved' &&
                                       selected.id)}
              beginDrag={this.beginDrag}
              endDrag={this.endDrag}
              onFilterSelect={this.selectFilter(filter)}
              move={this.move}
            />)}
          </ul>
        </Fragment>}
      </Fragment>)}
    </div>);
  }
}

SavedFiltersList.propTypes = {
  savedFilters: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    filters: PropTypes.object,
    overdue_count: PropTypes.number,
    count: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
  })).isRequired,
  assignedFilters: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    filters: PropTypes.object,
    id: PropTypes.number,
  })).isRequired,
  all_phase_count: PropTypes.number,
  all_phase_overdue_count: PropTypes.number,
  selected: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  filters: PropTypes.object,
  onFilterSelect: PropTypes.func.isRequired,
  updateSavedFilterPosition: PropTypes.func.isRequired,
  updateSavedFilter: PropTypes.func.isRequired,
  ignoreLocationFilters: PropTypes.bool,
  hideSaved: PropTypes.bool,
  role: PropTypes.string,
  onSupervisorChange: PropTypes.func,
  canAccessSupervisorFilter: PropTypes.bool,
};

SavedFiltersList.defaultProps = {
  filters: {},
  savedFilters: [],
  assignedFilters: [],
  canAccessSupervisorFilter: false,
};

const mapStateToProps = state => ({
  savedFilters: state.savedFilters.filters,
  assignedFilters: state.assignedFilters.filters,
  filters: state.phases.filters.data,
  all_phase_count: state.phases.pagination.all_phase_count,
  all_phase_overdue_count: state.phases.pagination.all_phase_overdue_count,
});

export default DragDropContext(HTML5Backend)(connect(mapStateToProps, {
  updateSavedFilterPosition, updateSavedFilter,
})(SavedFiltersList));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseList/components/SavedFiltersList.jsx